import { AxiosResponse } from "axios";

import axios from "../apis/django.instance";
import { dispatchError } from "../utils/error.util";
export interface GetProjectsServiceData {
  archived_yn?: ProjectObject["archived_yn"];
  workspace?: ProjectObject["workspace"];
  search?: ProjectObject["title"];
}
export type GetProjectsServiceResponse = Promise<AxiosResponse<ProjectArray>>;
export type GetProjectsService = (
  data?: GetProjectsServiceData
) => GetProjectsServiceResponse;
export const getProjectsListService: GetProjectsService = (data) => {
  if (data) {
    return axios.get("/api/projects/project/", {
      params: {
        ...data,
      },
    });
  } else {
    return axios.get("/api/projects/project/");
  }
};

export type CreateProjectService = (
  payload: ProjectObject
) => Promise<AxiosResponse<any>>;
export const createProjectService: CreateProjectService = (payload) => {
  return axios.post("/api/projects/project/", payload);
};

export type UpdateProjectService = (
  payload: ProjectObject
) => Promise<AxiosResponse<any>>;
export const updateProjectService: UpdateProjectService = (payload) => {
  const { id, ...rest } = payload;
  return axios.patch(`/api/projects/project/${id}/`, rest);
};

/**
 * Project Workday Services
 */
interface RemoveProjectFromWorkdayServiceData {
  project: ProjectObject["id"];
  user: UserDetailsObject["id"];
  work_day: WorkDayObject["id"];
}
interface RemoveProjectFromWorkdayServiceResponse {
  project: ProjectObject["id"];
  user: UserDetailsObject["id"];
  work_day: WorkDayObject["id"];
}
type RemoveProjectFromWorkdayService = (
  data: RemoveProjectFromWorkdayServiceData
) => Promise<AxiosResponse<RemoveProjectFromWorkdayServiceResponse>>;

export const addProjectToWorkDayService: RemoveProjectFromWorkdayService = (
  data
) => axios.post(`/api/work/workday_project/`, data);

export const removeProjectFromWorkDayService: RemoveProjectFromWorkdayService = (
  data
) => axios.delete(`/api/work/workday_project/`, { data });

export interface ProjectMemberObject {
  access_type_enum: "member" | "owner";
  id: string;
  project: ProjectObject["id"];
  project_role: string;
  user: UserDetailsObject["id"];
}
export type ProjectMemberArray = ProjectMemberObject[];
export const getMyProjectMemberships = async () => {
  try {
    const response = await axios.get(
      "/api/projects/project_memberships/my_memberships/"
    );
    if (response.status === 200) {
      return response.data as ProjectMemberArray;
    } else {
      throw new Error();
    }
  } catch (e) {
    dispatchError({
      e,
      title: "Get project memberships error",
    });
    return null;
  }
};

export interface ResponseProjectObejct extends Omit<ProjectObject, "color"> {
  color: ProjectColorObject["id"];
}
export const getProjectRecord = async (projectId: ProjectObject["id"]) => {
  try {
    const response = await axios.get(`/api/projects/project/${projectId}`);
    if (response.status === 200) {
      return response.data as ResponseProjectObejct;
    } else {
      throw new Error();
    }
  } catch (e) {
    dispatchError({
      e,
      title: "Get project record error",
    });
    return null;
  }
};
